import React, { ReactElement } from 'react';

import type { CompanyInterface } from 'interfaces/company.interface';
import { BadgeType } from 'interfaces/badge.interface';
import Badge from 'components/badge/badge';

import sskImage from 'assets/images/company-view/ssk.inline.svg';
import credibilityImage from 'assets/images/company-view/credibility-badge.png';
import usingCredibleReviewsImage from 'assets/images/company-view/using-credible-reviews-badge.inline.svg';

const CompanyViewBadges: React.FC<{ company: CompanyInterface; }> = ({ company }): ReactElement => {
    const rankingBadges = company.ranking?.map((item): ReactElement => {
        let alt = `${item.category.name} ${item.year}`;

        if (item.placeNumber) {
            alt += ` - ${item.placeNumber} miejsce`;
        }

        return (
            <li key={item.badgeIconUrlSmall} className="company-view-header__badges-item">
                <Badge
                    src={item.badgeIconUrlSmall || ''}
                    alt={alt}
                    className="company-view-header__badge-image"
                    type={BadgeType.RANKING}
                    item={item}
                />
            </li>
        );
    });

    const badge = company.badge && (
        <li className="company-view-header__badges-item">
            <Badge
                src={company.badge?.iconUrl}
                alt={company.badge?.name}
                className="company-view-header__badge-image"
                type={BadgeType.NORMAL}
                item={company.badge}
            />
        </li>
    );

    const sskBadge = company.isCustomer && (
        <li className="company-view-header__badges-item">
            <Badge src={sskImage} alt="Słucham swoich klientów" className="company-view-header__badge-image" type={BadgeType.SSK}/>
        </li>
    );

    const credibilityBadge = company.isCredibilityVerified && (
        <li className="company-view-header__badges-item">
            <Badge src={credibilityImage} alt="Certyfikat Opineo" className="company-view-header__badge-image" type={BadgeType.NORMAL}/>
        </li>
    );

    const usingCredibleReviewsBadge = company.usingCredibleReviews && (
        <li className="company-view-header__badges-item">
            <Badge
                src={usingCredibleReviewsImage}
                alt="Ten sklep ma wdrożony System Wiarygodnich Opinii"
                className="company-view-header__badge-image"
                type={BadgeType.CREDIBLE}
            />
        </li>
    );

    return (
        <ul className="company-view-header__badges">
            {usingCredibleReviewsBadge}
            {rankingBadges}
            {badge}
            {sskBadge}
            {credibilityBadge}
        </ul>
    );
};

export default CompanyViewBadges;
